import ApiService from '@/core/services/ApiService';
import { endpoints } from '@/core/services/Endpoints';

export async function fetchStatistics() {
    const res = await ApiService.axios.get(endpoints.dashboard_statistics);
    return res.data?.data || null;
}

export async function fetchStorageQuota() {
    const res = await ApiService.axios.get(endpoints.storage_quota);
    return res.data?.data || null;
}

export async function fetchModuleWidgets(specs) {
    if (!Array.isArray(specs) || !specs.length) return [];
    const res = await ApiService.axios.post(endpoints.module_widget, {
        widgets: specs,
    });
    return Array.isArray(res.data?.data) ? res.data.data : [];
}

export function findModuleWidget(items, moduleId, code) {
    if (!Array.isArray(items)) return null;
    return items.find(w => w.module_id === moduleId && w.code === code) || null;
}
